import { cn } from 'ui'
import { usePDFStore } from '../../../stores/pdf.store'
import { CursorField } from './CursorField'
import { EditableField } from './EditableField'
import { useCallback, useEffect } from 'react'

export const CanvasFieldsEditLayer = () => {
  const focusedBlock = usePDFStore((state) => state.focusedBlock)
  const update = usePDFStore((state) => state.update)
  const fields = usePDFStore((state) => state.fields)
  const blurCurrentEditingField = usePDFStore(
    (state) => state.blurCurrentEditingField
  )
  const isDocumentReady = usePDFStore((state) => state.isDocumentReady)
  const removeCurrentEditingField = usePDFStore(
    (state) => state.removeCurrentEditingField
  )

  const handleKeyDown = useCallback((ev: KeyboardEvent) => {
    if (
      ev.target &&
      ev.target instanceof HTMLElement &&
      ['input', 'textarea'].includes(ev.target.tagName.toLowerCase())
    ) {
      console.log('key down came from input. ignoring')

      return
    }

    switch (ev.key) {
      case 'Escape':
        return blurCurrentEditingField()

      case 'Delete':
      case 'Backspace':
        return removeCurrentEditingField()
    }
  }, [])

  useEffect(() => {
    window.addEventListener('keyup', handleKeyDown)

    return () => {
      window.removeEventListener('keyup', handleKeyDown)
    }
  }, [])

  return (
    <>
      <div className='absolute z-10'>{focusedBlock && <CursorField />}</div>
      <div
        id='fields-edit-layer'
        className={cn('opacity-0', {
          'opacity-100': isDocumentReady,
        })}
      >
        {fields.map((field, index) => (
          <EditableField key={field.id} field={field} index={index} />
        ))}
      </div>
    </>
  )
}
